/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import { withStyles, Grid } from '@material-ui/core';
import { Tween } from 'react-gsap';
import Triangles from '../../components/Triangles';

const styles = theme => ({
  home: {
    position: 'relative',
    overflow: 'hidden',
    width: '100vw',
    height: 'calc(100vw / 1.49)'
  },
  videoContainer: {
    display: 'block',
    height: 'calc(100vw / 1.49)',
    width: '100vw',
    position: 'absolute',
    zIndex: '1',
    top: '0',
    left: '0',
    overflow: 'hidden'
  },

  img: {
    paddingRight: '100px'
  },
  swLogo: {
    width: '60%',
    backfaceVisibility: 'hidden'
  },
  u2iLogo: {
    width: '35%',
    backfaceVisibility: 'hidden',
    [theme.breakpoints.down('sm')]: {
      width: '40%'
    }
  }
});

const Home = class extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <section className={classes.home}>
        <div className={classes.videoContainer}>
          <Triangles />
        </div>
        <div
          className="wrapper"
          style={{
            zIndex: 10
            // width: '100vw',
            // height: '100vh'
          }}
        >
          <Grid
            container
            direction="column"
            justify="center"
            alignItems="center"
            wrap="nowrap"
            style={{ height: 'calc(100vw / 1.79)', maxHeight: '100vh' }}
          >
            <Grid item style={{ zIndex: 100, textAlign: 'center' }}>
              <Tween
                from={{ opacity: 0, transform: 'scale(0)' }}
                // from={{ top: '-200px' }}
                // to={{ top: '0px' }}
                to={{ opacity: 1, transform: 'scale(1)' }}
                ease="Back.easeOut"
                duration={0.8}
                delay={2.2}
              >
                <img
                  className={classes.u2iLogo}
                  src="/images/u2i-logo.png"
                  alt="u2i logo"
                />
              </Tween>
            </Grid>
            <Grid item style={{ zIndex: 100, textAlign: 'center' }}>
              <Tween
                from={{ opacity: 0, transform: 'scale(0)' }}
                to={{ opacity: 1, transform: 'scale(1)' }}
                duration={0.8}
                ease="Back.easeOut"
                delay={2.2}
              >
                <img
                  className={classes.swLogo}
                  src="/images/softwar-logo.png"
                  alt="SoftWar Logo"
                />
              </Tween>
            </Grid>
          </Grid>
        </div>
      </section>
    );
  }
};

export default withStyles(styles)(Home);
